<template>
  <account-container title="Logged out">
  
  </account-container>
</template>

<script>
import AccountContainer from '@/components/AccountContainer.vue'
export default {
  name: 'login',
  components: {
    AccountContainer,
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {
    localStorage.clear();
    this.$store.dispatch('authentication/logout')
    this.$store.dispatch('myclaims/reset')
    this.$store.dispatch('claimform/reset')
    this.$store.dispatch('repairoptions/reset')
  },
  methods: {

  }
}
</script>
